import { useEffect } from "react";
import { SubsidioMutuo, useSubsidioMutuo } from "../../hooks/useSubsidioMutuo";
import { Control, FieldErrors, useForm } from "react-hook-form";
import InputNumber from "../../../../components/inputs/yup/materialui/inputNumber";
import InputText from "../../../../components/inputs/yup/materialui/inputText";
import InputSelect from "../../../../components/inputs/yup/materialui/inputSelect";
import { Card, CardContent, Grid2, Typography } from "@mui/material";
import { operacion } from "../../models/operacion";
import { selectorTransversal } from "../../../../dtos/selector";
interface IProps {
    mutuoId: number;
    setDatosSubsidio: (subsidioFormData: SubsidioMutuo | undefined) => void
    control: Control<operacion>
    tipoSubsidios: selectorTransversal[]
    beneficios: selectorTransversal[]
    isEditing: boolean;
    isComplementario: boolean;
    isReadonlyWithPermission : () => boolean;
    isReadonlyStandardCarteraMutuo: () => boolean;
    error: FieldErrors<operacion>;
}

const SubsidioForm: React.FC<IProps> = (props) => {
    const { control, tipoSubsidios, isEditing, isComplementario, isReadonlyWithPermission, isReadonlyStandardCarteraMutuo, error } = props;
    const { obtenerBancos, selectorBancos } = useSubsidioMutuo(props.mutuoId);   

    useEffect(() => {
        obtenerBancos();
    }, []);

    return (
        <Card sx={{ mb: 2, backgroundcolor: 'white' }} raised>
            <CardContent>
                <Typography className='card-title' variant="h6" gutterBottom>
                    Datos subsidio
                </Typography>
                <Grid2 container spacing={2} sx={{ mt: 2 }}>

                    {/* <h5>Datos subsidio</h5> */}
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            label="Tipo subsidio"
                            name="tipoSubsidio"
                            control={control}
                            options={tipoSubsidios}
                            readonly={isReadonlyWithPermission()}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Subsidio"
                            name="subsidio"
                            control={control}
                            prefix="UF"
                            decimales={4}
                            readonly={isReadonlyWithPermission()}
                            maxValue={999999999}
                            
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Ahorro"
                            name="ahorro"
                            control={control}
                            prefix="UF"
                            decimales={4}
                            readonly={isReadonlyWithPermission()}
                            maxValue={999999999}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Serie"
                            name="serie"
                            control={control}
                            readonly={isReadonlyWithPermission()}
                            error={error.serie}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Número libreta"
                            name="libreta"
                            control={control}
                            readonly={isReadonlyWithPermission()}
                            error={error.libreta}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Bono captación"
                            name="bonoCaptacion"
                            control={control}
                            prefix="UF"
                            decimales={4}
                            readonly={isReadonlyWithPermission()}
                            maxValue={999999999}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputNumber
                            label="Bono integración"
                            name="bonoIntegracion"
                            control={control}
                            prefix="UF"
                            decimales={4}
                            readonly={isReadonlyWithPermission()}
                            maxValue={999999999}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Resolución exenta"
                            name="resolucion"
                            control={control}
                            readonly={isReadonlyWithPermission()}
                            error={error.resolucion}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputText
                            label="Código proyecto"
                            name="codProyecto"
                            control={control}
                            readonly={isReadonlyWithPermission()}
                            error={error.codProyecto}
                        />
                    </Grid2>

                    <Grid2 size={{ xs: 12, lg: 3 }}>
                        <InputSelect
                            label="Banco"
                            name="codigoBanco"
                            control={control}
                            options={selectorBancos}
                            readonly={isReadonlyWithPermission()}
                        />
                    </Grid2>
                </Grid2>
            </CardContent>
        </Card>


    )
}

export default SubsidioForm;